import React, { FunctionComponent } from 'react';

import styles from './HelpOthers.module.scss';

interface HelpOthersCardProps {
  title?: string;
  description?: string;
  imgSrc?: string;
  href?: string;
  visuallyHidden?: boolean;
  visuallyHiddenText?: string;
  btnLink?: string;
}

export const HelpOthersCard: FunctionComponent<HelpOthersCardProps> = ({
  title,
  description,
  imgSrc,
  href,
  visuallyHidden,
  visuallyHiddenText,
  btnLink,
}) => {
  return (
    <li className={styles.customLink}>
      <img src={imgSrc} alt="" />
      <div className={styles.customLinkContent}>
        <h3 className={`jg-h4 ${styles.subTitle}`}>{title}</h3>
        <p className={styles.customLinkDescription}>{description}</p>
      </div>
      <a href={href} className={styles.customLinkBtn}>
        {btnLink}
        {visuallyHidden ? (
          <span className="jg-sr-only">{visuallyHiddenText}</span>
        ) : (
          ''
        )}
      </a>
    </li>
  );
};
